import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { LocalStorageService } from 'angular-2-local-storage';
import { GlobalVariable } from './../shared/global';
@Injectable()
export class AuthService {
    // private baseApiUrl = GlobalVariable.BASE_API_URL;
    private baseApiUrlTest = GlobalVariable.BASE_API_URL;
    private headers = new Headers({ 'Content-Type': 'application/json' });
    // private rest api url variables
    // private sign_in_url = this.baseApiUrl + 'api/rest/v1/auth/login/';
    private sign_in_url = this.baseApiUrlTest + 'api/auth/login/';
    // private verify_otp_url = this.baseApiUrl + 'api/rest/v1/otp/verify/';
    private verify_mobile_otp_url = this.baseApiUrlTest + 'api/auth/verify/mobile';
    private verify_email_otp_url = this.baseApiUrlTest + 'api/auth/verify/email';
    // private verify_email_otp_url = this.baseApiUrlTest + 'api/rest/v1/otp/verify/email/';
    // private resend_otp_url = this.baseApiUrl + 'api/rest/v1/auth/otp/';
    private resend_otp_url = this.baseApiUrlTest + 'api/auth/send/otp/';
    private resend_express_otp_url = this.baseApiUrlTest + 'api/auth/send/express/otp/';
    private validate_otp_url = this.baseApiUrlTest + 'api/auth/validate/otp/';
    // private reset_password_url = this.baseApiUrl + 'api/rest/v1/auth/reset_password/';
    private reset_password_url = this.baseApiUrlTest + 'api/auth/forget/password/';
    private reset_admin_password_url = this.baseApiUrlTest + 'api/admin/forget/password/';
    // private new_password_url = this.baseApiUrl + 'api/rest/v1/auth/done/reset_password/';
    private new_password_url = this.baseApiUrlTest + 'api/auth/reset/password';
    private new_admin_password_url = this.baseApiUrlTest + 'api/admin/reset/password';
    // private change_password_url = this.baseApiUrl + 'api/rest/v1/auth/change_password/';
    private change_password_url = this.baseApiUrlTest + 'api/auth/change/password';
    private query_email_for_ban = this.baseApiUrlTest + 'api/auth/GetEmailForBillingAccountNumber';
  constructor(private http: Http, private localStorageService: LocalStorageService) { }
    // rest api mobile otp verify
    verifyOTP(otp_verify: Object) {
        return this.http
            // .post(this.verify_otp_url, otp_verify)
            .post(this.verify_mobile_otp_url, otp_verify)
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    // rest api mobile otp verify
    verifyEmailOTP(otp_verify: Object) {
        return this.http
            .post(this.verify_email_otp_url, otp_verify)
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }
    // resend otp rest api
    resendOTP(mobile_no: Object) {
        return this.http
            .post(this.resend_otp_url, mobile_no)
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }
    resendOTPExpress(ban: number) {
      return this.http
        .post(this.resend_express_otp_url, { ban })
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
    }
    isValidOTP(ban: number) {
      return this.http
        .get(this.validate_otp_url + '?ban=' + ban)
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
    }
    // reset password
    resetPassword(username: Object) {
        return this.http
            .post(this.reset_password_url, username)
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }
    resetAdminPassword(username: Object) {
        return this.http
            .post(this.reset_admin_password_url, username)
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }
    signIn(sign_in_info: any): Promise<any> {
        return this.http
            .post(this.sign_in_url, sign_in_info)
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }
    createNewPassword(new_password: any): Promise<any> {
        return this.http
            .post(this.new_password_url, new_password)
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }
    createNewAdminPassword(new_password: any): Promise<any> {
        return this.http
            .post(this.new_admin_password_url, new_password)
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }
    changePassword(change_password: any): Promise<any> {
        return this.http
            .post(this.change_password_url, change_password)
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }
    getEmailFromBan(ban: string): Promise<any> {
      return this.http
        .get(this.query_email_for_ban + '?ban=' + ban)
        .toPromise()
        .then(res => res.json())
        .catch(this.handleError);
    }
    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts